// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FROM = "Od";
export const NO = "Nie";
export const number_MONTHS = ["%(number)s mesiac", "%(number)s mesiace", "%(number)s mesiacov"];
export const STROLLER_FEATURE_RECOMMENDED_AGE_MORE_MONTHS = "a viac";
export const STROLLERS_SEARCH_FACET_BRAND = "Zna\u010dka";
export const TO = "Do";
export const YES = "\u00c1no";
